import { Delete20Regular } from '@fluentui/react-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../Button';
import './EmailMultiSelectionPanel.scss';

export interface EmailMultiSelectionPanelProps {
  selectedCount: number;
  deleteClick: () => void;
  cancelClick: () => void;
  isDeleting: boolean;
}

export const EmailMultiSelectionPanel: React.FC<EmailMultiSelectionPanelProps> = ({
  selectedCount,
  deleteClick,
  cancelClick,
  isDeleting,
}) => {
  const { t } = useTranslation();

  return (
    <div className="emailMultiSelectionPanel" data-testid="emailMultiSelectionPanel" role="status">
      <h2 className="emailMultiSelectionPanelHeadline">
        {t('email_multi_selection_count', {
          defaultValue: '{{total}} E-Mails ausgewählt',
          total: selectedCount,
        })}
      </h2>
      <div className="emailMultiSelectionPanelActions">
        <Button
          appearance="primary"
          icon={<Delete20Regular />}
          onClick={deleteClick}
          loading={isDeleting}
          disabled={isDeleting}
          data-testid="deleteSelectedEmailsBtn"
        >
          {t('email_delete_selected', {
            defaultValue: 'Ausgewählte E-Mails löschen',
          })}
        </Button>
        <Button onClick={cancelClick} disabled={isDeleting} data-testid="cancelEmailSelectionBtn">
          {t('cancel', { defaultValue: 'Abbrechen' })}
        </Button>
      </div>
    </div>
  );
};
